<template>
  <v-layout align-center column>
    <p class="Section-Title">Kategori Pendanan</p>
    <v-row v-if="!isMobile" v-row justify="center">
      <!-- <v-col>
        <div class="Shape">
          <img
            src="../../assets/pinjaman/AgriKilat-Logo.png"
            srcset="
              ../../assets/pinjaman/AgriKilat-Logo@2x.png 2x,
              ../../assets/pinjaman/AgriKilat-Logo@3x.png 3x
            "
            class="AgriKilat-Logo"
          />
          <p class="Desc">
            Wujudkan ketahanan pangan Indonesia dengan menanam dana, nikmati
            hasil panen bersama petani & peternak.
          </p>
        </div>
      </v-col> -->
      <v-col>
        <div class="Shape Warna-ModalKilat">
          <img
            src="../../assets/pinjaman/ModalKilat-Logo.png"
            srcset="
              ../../assets/pinjaman/ModalKilat-Logo@2x.png 2x,
              ../../assets/pinjaman/ModalKilat-Logo@3x.png 3x
            "
            class="ModalKilat-Logo"
          />
          <p class="Desc">
            Lakukan penanaman modal untuk usaha potensial, dapatkan keuntungan
            finansial yang menarik.
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="Shape Warna-GajiKilat">
          <img
            src="../../assets/pinjaman/GajiKilat-Logo.png"
            srcset="
              ../../assets/pinjaman/GajiKilat-Logo@2x.png 2x,
              ../../assets/pinjaman/GajiKilat-Logo@3x.png 3x
            "
            class="GajiKilat-Logo"
          />
          <p class="Desc">
            Membantu karyawan untuk memperoleh gaji lebih cepat, serta tumbuhkan
            uang dengan pasti.
          </p>
        </div>
      </v-col>
    </v-row>

    <!-- <div v-if="isMobile" class="Shape" style="margin: 10px;">
      <img
        src="../../assets/pinjaman/AgriKilat-Logo.png"
        srcset="
          ../../assets/pinjaman/AgriKilat-Logo@2x.png 2x,
          ../../assets/pinjaman/AgriKilat-Logo@3x.png 3x
        "
        class="AgriKilat-Logo"
      />
      <p class="Desc">
        Wujudkan ketahanan pangan Indonesia dengan menanam dana, nikmati hasil
        panen bersama petani & peternak.
      </p>
    </div> -->

    <div v-if="isMobile" class="Shape Warna-ModalKilat" style="margin: 10px;">
      <img
        src="../../assets/pinjaman/ModalKilat-Logo.png"
        srcset="
          ../../assets/pinjaman/ModalKilat-Logo@2x.png 2x,
          ../../assets/pinjaman/ModalKilat-Logo@3x.png 3x
        "
        class="ModalKilat-Logo"
      />
      <p class="Desc">
        Lakukan penanaman modal untuk usaha potensial, dapatkan keuntungan
        finansial yang menarik.
      </p>
    </div>

    <div v-if="isMobile" class="Shape Warna-GajiKilat" style="margin: 10px;">
      <img
        src="../../assets/pinjaman/GajiKilat-Logo.png"
        srcset="
          ../../assets/pinjaman/GajiKilat-Logo@2x.png 2x,
          ../../assets/pinjaman/GajiKilat-Logo@3x.png 3x
        "
        class="GajiKilat-Logo"
      />
      <p class="Desc">
        Membantu karyawan untuk memperoleh gaji lebih cepat, serta tumbuhkan
        uang dengan pasti.
      </p>
    </div>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
    };
  },
  created() {
    console.log("asdasd", window.innerWidth);
    if (window.innerWidth >= 500) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },
};
</script>
<style scoped>
.Section-Title {
  width: 237px;
  height: 30px;
  flex-grow: 0;
  margin: 70px 100px 60px 101px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Shape {
  width: 320px;
  height: 131px;
  flex-grow: 0;
  /* margin-right: 10px; */
  /* margin: 60px 29px 0 0; */
  /* padding: 20px 20px 20px 21px; */
  border-radius: 8px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  border: solid 2px #3bb54a;
  background-color: #ffffff;
}
.Warna-ModalKilat {
  border: solid 2px #efaf0b;
}
.Warna-GajiKilat {
  border: solid 2px #0ce4f2;
}
.AgriKilat-Logo {
  width: 75.1px;
  height: 20px;
  flex-grow: 0;
  margin: 10px auto 8px auto;
  object-fit: contain;
  display: block;
}

.ModalKilat-Logo {
  width: 92.7px;
  height: 17px;
  flex-grow: 0;
  margin: 10px auto 11px auto;
  object-fit: contain;
  display: block;
}
.GajiKilat-Logo {
  width: 73px;
  height: 20px;
  flex-grow: 0;
  margin: 10px auto 8px auto;
  object-fit: contain;
  display: block;
}

.Desc {
  width: 292px;
  height: 63px;
  flex-grow: 0;
  margin: 0 10px 0 10px;
  font-family: Inter;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
</style>
